import {css, Theme} from "@emotion/react";

import {m} from "@pg-design/helpers-css";
import {borderRadius, p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";

import {UserPhoneVerificationForm} from "./UserPhoneVerificationForm";

interface IProps {
    isOpen: boolean;
    onClose?: () => void;
    onSuccess?: () => void;
    onChangeNumber: () => void;
    phoneNumber?: string;
}

export const UserPhoneVerification = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber, phoneNumber} = props;

    return (
        <Modal isOpen={isOpen} onModalClose={onClose} css={modalStyle}>
            <Modal.CloseButton
                placement="right"
                variant="rounded"
                css={css`
                    ${m(2)}
                `}
            />
            <Modal.Content>
                <UserPhoneVerificationForm onClose={onClose} isOpen={isOpen} onSuccess={onSuccess} onChangeNumber={onChangeNumber} phoneNumber={phoneNumber} />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(2)};
        ${borderRadius(2)};
        width: 544px;
        height: 448px;
    }
`;
import {css, Theme} from "@emotion/react";

import {m} from "@pg-design/helpers-css";
import {borderRadius, p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";

import {UserPhoneVerificationForm} from "./UserPhoneVerificationForm";

interface IProps {
    isOpen: boolean;
    onClose?: () => void;
    onSuccess?: () => void;
    onChangeNumber: () => void;
    phoneNumber?: string;
}

export const UserPhoneVerification = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber, phoneNumber} = props;

    return (
        <Modal isOpen={isOpen} onModalClose={onClose} css={modalStyle}>
            <Modal.CloseButton
                placement="right"
                variant="rounded"
                css={css`
                    ${m(2)}
                `}
            />
            <Modal.Content>
                <UserPhoneVerificationForm onClose={onClose} isOpen={isOpen} onSuccess={onSuccess} onChangeNumber={onChangeNumber} phoneNumber={phoneNumber} />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(2)};
        ${borderRadius(2)};
        width: 544px;
        height: 448px;
    }
`;
